import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ConfirmationModal } from "@air/component-confirmation-modal";
import { memo } from "react";
export const BoardCollectionSubmissionModal = /*#__PURE__*/ memo((param)=>{
    let { onSubmit, onClose, isLoading } = param;
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        id: "board-collection-submission-modal",
        isOpen: true,
        title: "Submit content",
        description: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    children: "Ready to submit?"
                }),
                /*#__PURE__*/ _jsx("p", {
                    children: "Your content will be shared with the form creator."
                })
            ]
        }),
        onDismiss: onClose,
        ctaSecondaryText: "Cancel",
        ctaPrimaryText: "Submit",
        onConfirm: onSubmit,
        isLoading: isLoading
    });
});
BoardCollectionSubmissionModal.displayName = "BoardCollectionSubmissionModal";
